import clsx from 'clsx';
import React, { useState, useEffect } from 'react';

import Button from '../../common/Elements/Button/Button';
import Icon, { ICONS } from '../../common/Elements/Icon/Icon';
import { useGetLegalConsent } from '../../requestLegalConsent/api/getLegalConsent';
import { useUpdateLegalConsent } from '../../requestLegalConsent/api/updateLegalConsent';

const CookieConsentModal = () => {
  const [isCookieAccepted, setIsCookieAccepted] = useState(() => {
    const storedCookieConsent = localStorage.getItem('cookieConsent');

    return storedCookieConsent ? JSON.parse(storedCookieConsent) : null;
  });
  const updateLegalConsentMutation = useUpdateLegalConsent({});
  const getLegalConsentQuery = useGetLegalConsent({
    config: {
      enabled: isCookieAccepted === null, // Only fetch if no stored consent
    },
  });

  useEffect(() => {
    if (getLegalConsentQuery.data) {
      const consentStatus = getLegalConsentQuery.data.consents.cookies;
      setIsCookieAccepted(consentStatus);
      localStorage.setItem('cookieConsent', JSON.stringify(consentStatus));
    }
  }, [getLegalConsentQuery.data]);

  const handleAccept = () => {
    updateLegalConsentMutation.mutateAsync({
      consents: {
        cookies: true,
      },
    });
    localStorage.setItem('cookieConsent', JSON.stringify(true));
    setIsCookieAccepted(true);
  };

  // If consent is already given or not determined, don't render modal
  if (isCookieAccepted === null || isCookieAccepted === true) {
    return null;
  }

  return (
    <div
      className={clsx(
        'cookie-consent-banner',
        'tw-flex tw-flex-col tw-fixed tw-bottom-[25px] tw-right-[25px] tw-w-[620px] tw-h-auto tw-gap-[40px]',
        'tw-z-[9999]'
      )}
    >
      <div
        className={clsx(
          'tw-flex tw-flex-col',
          'tw-max-w-full tw-h-auto tw-p-[20px] tw-bg-[#414A4F] tw-text-white tw-rounded-[10px] tw-gap-[5px]'
        )}
      >
        {/* <Button
          className={clsx(
            'tw-absolute tw-top-[2px] tw-right-[8px] tw-pr-[8px] tw-pt-[15px] ',
            'tw-text-white tw-w-[18px] tw-h-[18px]'
          )}
          onClick={() => {}}
        >
          <Icon icon={ICONS.close} />
        </Button> */}

        <div className="header tw-flex tw-items-center tw-justify-between tw-max-w-full tw-h-[27px] tw-gap-[5px]">
          <div className="tw-flex tw-items-center tw-gap-[5px]">
            <Icon icon={ICONS.cookie_icon({ className: 'tw-text-white' })} />
            <span className="tw-ml-2 tw-text-[18px] tw-leading-[27px] tw-w-[420px] tw-h-[27px] tw-font-[420]">
              Why we use cookies
            </span>
          </div>
        </div>

        <p className="tw-w-[580px] tw-max-h-[42px] tw-text-white tw-text-[14px] tw-leading-[21px] tw-gap-[10px] tw-font-[390]">
          We use cookies to enhance your experience and support the development
          and improvements to our WebApp.
        </p>
        <div className="tw-flex tw-justify-end tw-w-[580px] tw-max-h-[32px] tw-gap-[10px]">
          <Button
            className="tw-text-white tw-w-[100px] tw-max-h-[32px]"
            buttonClassSettings={{
              variant: 'secondary',
              size: 'md',
              position: 'center',
            }}
            onClick={handleAccept}
          >
            <span className="tw-text-[14px] tw-leading-[27px] tw-font-[420]">
              Accept
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentModal;
